<script>
  let { method } = $props();
  const cls = $derived(['GET','POST','PUT','PATCH','DELETE'].includes(method) ? `method-${method}` : 'method-OTHER');
</script>
<span class="method-chip {cls}">{method}</span>
